"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reflux = _interopRequireDefault(require("reflux"));

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _PushHelperStrings = require("./PushHelperStrings");

var _UserManagementService = _interopRequireDefault(require("../common/components/Equizzer/services/UserManagementService"));

var _ErrorHelper = require("./ErrorHelper");

var _MuiAlertHelper = require("./MuiAlertHelper");

var _KeyboardHelper = require("./KeyboardHelper");

var _TimeoutHelper = require("./TimeoutHelper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var PushHelper = /*#__PURE__*/function (_Reflux$Component) {
  (0, _inherits2["default"])(PushHelper, _Reflux$Component);

  var _super = _createSuper(PushHelper);

  (0, _createClass2["default"])(PushHelper, null, [{
    key: "showPushDialog",
    value: function () {
      var _showPushDialog = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(receiver, sender, onDone) {
        var pushHelper;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pushHelper = new PushHelper();
                pushHelper.setOnDone(onDone);
                _context.prev = 2;
                _context.next = 5;
                return pushHelper.showPushDialog(receiver, sender);

              case 5:
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](2);
                console.log('error', _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 7]]);
      }));

      function showPushDialog(_x, _x2, _x3) {
        return _showPushDialog.apply(this, arguments);
      }

      return showPushDialog;
    }()
  }]);

  function PushHelper(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, PushHelper);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSuccess", function () {
      if (_this.onExternalDone) {
        _this.onExternalDone();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onFail", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              (0, _KeyboardHelper.hideKeyboard)();
              _context2.next = 3;
              return (0, _TimeoutHelper.timeout)(200);

            case 3:
              _this.onFailPromise();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "changePushMessage", function (evt) {
      _this.pushMsg = evt.target.value;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "showPushDialog", function (receiver, sender) {
      var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var sendButton = {
        label: (0, _PushHelperStrings.getString)('SEND_PUSH'),
        callback: function callback() {
          _this.sendPush(receiver, sender);
        }
      };
      var cancelButton = {
        label: (0, _PushHelperStrings.getString)('CANCEL'),
        callback: function callback() {}
      };
      (0, _MuiAlertHelper.showWideAlertHtmlWithTextfields)((0, _PushHelperStrings.getString)('ENTER_PUSH_TEXT', [receiver.firstname, receiver.lastname]), (0, _PushHelperStrings.getString)('ENTER_PUSH_TEXT_TITLE'), error, [// {
      //   label: getString('PUSH_MESSAGE_TITLE'),
      //   onChange: this.changePushTitle
      //
      // },
      {
        label: (0, _PushHelperStrings.getString)('PUSH_MESSAGE'),
        onChange: _this.changePushMessage
      }], true, null, [cancelButton, sendButton]);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "sendPush", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(receiver, sender) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('sending push to user', receiver, sender);

                if (_this.pushMsg) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return", _this.showPushDialog(receiver, sender, (0, _PushHelperStrings.getString)('ENTER_A_MESSAGE')));

              case 3:
                _context3.prev = 3;

                if (!(receiver && receiver.username)) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 7;
                return _UserManagementService["default"].sendPush([receiver.username], _this.pushMsg, "Neue Nachricht von ".concat(sender.firstName, " ").concat(sender.lastName));

              case 7:
                response = _context3.sent;
                console.log('sendPush response', response);

                if (response.success) {
                  _this.pushMsg = null;
                  _this.pushTitle = null;

                  _this.onSuccess();
                } else {
                  _this.onFail();
                }

              case 10:
                _context3.next = 16;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](3);
                console.log('sendPush error', _context3.t0);

                _this.showPushDialog(receiver, (0, _ErrorHelper.getErrorMessage)(_context3.t0));

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 12]]);
      }));

      return function (_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.pushMsg = null;
    _this.pushTitle = null;
    _this.onExternalDone = null;
    return _this;
  }

  (0, _createClass2["default"])(PushHelper, [{
    key: "setOnDone",
    value: function setOnDone(onDone) {
      this.onExternalDone = onDone;
    }
  }]);
  return PushHelper;
}(_reflux["default"].Component);

var _default = PushHelper;
exports["default"] = _default;